import type { ReactNode } from 'react'
import { useEffect, useRef } from 'react'

import PopoverBody from './body'
import PopoverButton from './button'
import PopoverHeader from './header'

import '@hotmart/cosmos/dist/popover'

type PopoverProps = {
  position?: 'top' | 'right' | 'bottom' | 'left'
  children?: ReactNode
  autoShow?: boolean
  className?: string
}

type HotPopoverElement = HTMLDivElement & {
  openPopover: () => void
}

const Popover = ({ children, className, position = 'top', autoShow = false }: PopoverProps) => {
  const hotPopoverElement = useRef<HotPopoverElement>(null)

  useEffect(() => {
    if (autoShow && hotPopoverElement.current) {
      hotPopoverElement.current.openPopover()
    }
  }, [autoShow])

  return (
    <hot-popover ref={hotPopoverElement} position={position} class={className}>
      {children}
    </hot-popover>
  )
}

Popover.Button = PopoverButton
Popover.Header = PopoverHeader
Popover.Body = PopoverBody

export default Popover
